import React from 'react';
import Meta from 'src/components/Meta';
import { useGaEventPageView } from 'src/utils/gaEvent';
import styled from 'styled-components';
import { AssessmentCardSkeleton, PageContainer, Poppins, Spacer } from 'src/common';
import { FrameworkLibraryCard } from './comps';
import { Link, useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { Tile, TileContainer, TileTitle } from 'src/components/Tile';
import { mpEvent } from 'src/utils/mixpanel/useMixPanel';
import { MPEvents } from 'src/utils/mixpanel/types';
import { useControlFrameworksListQuery } from 'src/graphql/_generated';
import { isQueryLoading } from 'src/graphql/client';

const Div = styled(PageContainer)`
  .panel {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    grid-gap: 15px;
  }

  .error {
    color: ${({ theme }) => theme.colors.error};
    font-size: 14px;
  }
  .success {
    color: ${({ theme }) => theme.colors.success};
    font-size: 14px;
  }
`;

const FrameworkLibrariesPage = () => {
  const navigate = useNavigate();
  useGaEventPageView('Cydea | Control Frameworks');

  const { data, loading, networkStatus } = useControlFrameworksListQuery();
  const isLoading = isQueryLoading({ loading, data, networkStatus });

  return (
    <>
      <Meta title={`Cydea | Control Frameworks`} feedbackScript />
      <Div>
        <Poppins px={32} weight={600}>
          Control Frameworks
        </Poppins>
        <Spacer $px={20} />
        <TileContainer>
          {!isLoading ? (
            <>
              <Tile
                className="hover-shadow"
                data-cy="all-controls-card"
                onClick={() => {
                  navigate('/control-frameworks/all-controls');
                  mpEvent(MPEvents.Link, {
                    source: {
                      value: ['Frameworks'],
                    },
                    destination: { value: ['Framework Controls all'] },
                    tags: ['FRAMEWORK'],
                  });
                }}
              >
                <Link
                  to="/control-frameworks/all-controls"
                  onClick={(e) => {
                    e.stopPropagation();
                    mpEvent(MPEvents.Link, {
                      source: {
                        value: ['Frameworks'],
                      },
                      destination: { value: ['Framework Controls all'] },
                      tags: ['FRAMEWORK'],
                    });
                  }}
                >
                  <TileTitle>View All Controls</TileTitle>
                </Link>
              </Tile>
              {_.orderBy(data?.controlFrameworks, [(item) => item.shortname?.toLowerCase()]).map((el) => (
                <FrameworkLibraryCard key={el.id} framework={el} />
              ))}
            </>
          ) : (
            <>
              <AssessmentCardSkeleton />
              <AssessmentCardSkeleton />
              <AssessmentCardSkeleton />
            </>
          )}
        </TileContainer>
      </Div>
    </>
  );
};

export default FrameworkLibrariesPage;
